/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Sensor_Warning_Hr_All_ZeroInputs */

const en_ui_sensor_warning_hr_all_zero = /** @type {(inputs: Ui_Sensor_Warning_Hr_All_ZeroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heart rate is zero for the whole session — sensor not connected`)
};

const de_ui_sensor_warning_hr_all_zero = /** @type {(inputs: Ui_Sensor_Warning_Hr_All_ZeroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herzfrequenz war die ganze Einheit 0 – Sensor nicht verbunden`)
};

/**
* | output |
* | --- |
* | "Heart rate is zero for the whole session — sensor not connected" |
*
* @param {Ui_Sensor_Warning_Hr_All_ZeroInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_sensor_warning_hr_all_zero = /** @type {((inputs?: Ui_Sensor_Warning_Hr_All_ZeroInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Sensor_Warning_Hr_All_ZeroInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_sensor_warning_hr_all_zero(inputs)
	return de_ui_sensor_warning_hr_all_zero(inputs)
});